<script setup lang="ts">
import PhaseInfoCell from '@ui-kit/components/PhaseInfoCell.vue'
import { PATIENT_UNIT as UNIT, type MemberUnitType } from '@/scripts/configs/patient-units'
import type { MemberDrawerProtocolInfo } from '@/components/drawers/MemberDrawer/types/member-drawer.types'

defineProps<{
  unit: MemberUnitType,
  protocol?: MemberDrawerProtocolInfo,
  bloomProgramName?: string,
  noPodSessionsAllowed?: boolean
}>()

</script>

<template>
  <div>
    <p v-if="unit === UNIT.BLOOM" class="my-2">
      {{ $t(bloomProgramName || 'SIDEBAR.NO_PRESCRIPTION') }}
      <sword-tag
        v-if="noPodSessionsAllowed"
        class="ml-2"
        size="sm"
        color="blue"
      >
        {{ $t('NO_POD_SESSION.AVAILABLE') }}
      </sword-tag>
    </p>
    <template v-else>
      <phase-info-cell
        v-if="protocol"
        :current-phase="protocol.currentPhase"
        :total-phases="protocol.totalPhases"
        :start-date="protocol.startDate"
        :end-date="protocol.endDate"
        :name="protocol.name"
        :outdated="protocol.outdated"
      />
      <p v-else class="my-2">{{ $t("SIDEBAR.DEFAULT_PRESCRIPTION") }}</p>
    </template>
  </div>
</template>
